export const API_BASE_URL = process.env.REACT_APP_BASE_URL;


// export const API_BASE_URL = "https://prod-cmc-api.staging-host.com/api/vender/";
